import { render, staticRenderFns } from "./text-item.vue?vue&type=template&id=6aaadb92&scoped=true&"
import script from "./text-item.vue?vue&type=script&lang=js&"
export * from "./text-item.vue?vue&type=script&lang=js&"
import style0 from "./text-item.vue?vue&type=style&index=0&id=6aaadb92&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaadb92",
  null
  
)

export default component.exports